import * as THREE from 'three';
import Transition from './Transition.js';

export default class SceneTransition {
  constructor() {
    this.experience = new Transition();
    this.sizes = this.experience.sizes;
    this.scene = this.experience.scene;
      this.plane = new THREE.Mesh(
        new THREE.PlaneGeometry(2, 2, 1, 1),
        this.experience.videoMaterial
      ) 
      this.plane.position.set(0, -1, 0)
      this.scene.add(this.plane)

      this.refAspect = 1440/844

      const aspect = this.sizes.width / this.sizes.height

      this.plane.scale.x = aspect > this.refAspect ? 1 : this.refAspect / aspect
      this.plane.scale.y = aspect > this.refAspect ? 1 / this.refAspect * aspect : 1
  }

  resize() {

    const aspect = this.sizes.width / this.sizes.height

    this.plane.scale.x = aspect > this.refAspect ? 1 : this.refAspect / aspect
    this.plane.scale.y = aspect > this.refAspect ? 1 / this.refAspect * aspect : 1

  }
}